<template>
    <div class="d-flex px-4 py-2 px-md-2 py-md-4">
        <router-link :to="{ name: 'coordinatorBookingComponent' }" class="d-flex align-center back-to-booking-link">
            <v-icon color="primary" size="24" icon="mdi-arrow-left"></v-icon> Powrót do rezerwacji
        </router-link>
    </div>
    <div class="order-transport-component invicta pa-4 pa-md-2 ml-auto mr-auto">
        <div class="main-header text-left mb-6 mt-6">
            Zlecenie transportu materiału dawcy/dawczyni
        </div>

        <div class="order-transport-wrapper">
            <!-- <div class="order-transport-header text-left pa-md-6 pb-md-0 pa-0 pb-6 d-flex flex-row align-center">
                <img :src="box_icon" class="mr-2" /> Zlecenie transportu materiału dawcy/dawczyni
            </div> -->
            <div class="order-bar text-left pa-md-6 pa-0 d-flex flex-md-row flex-column align-start align-md-top">
                
                <div :class="['order-bar-element d-flex flex-column align-start mr-md-6', $vuetify.display.mobile ? 'w-100' : '' ]">
                    <div class="order-bar-label mb-2 mt-md-0 mt-4">
                        Identyfikator lub Nick dawcy/dawczyni
                    </div>
                    <div class="order-bar-select-wrapper">
                        <Select
                            v-model="order_transport_data.donor_material"
                            id="material"
                            :autocomplete="true"
                            :clearIcon="true"
                            :options="donorMaterials"
                            :placeholder="'np. K865428 lub Monik398'"
                            :filter="filter"
                            :sortData="true"
                            :class="invalidOrderTransportDonorMaterial ? 'error' : ''"
                            @change="onChangeDonorMaterial"
                        >
                            <template #option="{ option }">
                                <div class="d-flex flex-column">
                                    {{ option.name }}
                                    <span class="selectfield--item-subtitle">
                                        {{ option.value.material?.location?.city }}
                                    </span>
                                </div>
                            </template>
                        </Select>
                    </div>
                    <div v-if="order_transport_data.donor_material" class="mt-1 order-bar-info-text">
                        Miejsce przechowywania: {{ order_transport_data.donor_material.value?.material?.location?.city}}
                    </div>
                    <div v-if="invalidOrderTransportDonorMaterial" class="mt-1 order-bar-info-text error-text">
                        Proszę wybrać materiał dawcy/dawczyni.
                    </div>
                </div>
                <div :class="['order-bar-element d-flex flex-column align-start mr-md-6', $vuetify.display.mobile ? 'w-100' : '' ]">
                    <div class="order-bar-label mb-2 mt-md-0 mt-4">
                        Ilość materiału
                    </div>
                    <v-text-field 
                        v-model="order_transport_data.quantity"
                        class="d-flex align-center set-quantity"
                        type="number"
                        min="0"
                        :max="maxQuantity"
                        :disabled="order_transport_data.donor_material == null ? true : false"
                        label=""
                        variant="plain"
                        density="compact"
                        hide-details="auto"
                        >
                        <template v-slot:prepend>
                            <v-btn
                                icon
                                variant="plain"
                                size="default"
                                :disabled="order_transport_data.quantity <= 1 ? true : false"
                                @click="order_transport_data.quantity--"
                                >
                                <v-icon color="primary" size="24">mdi-minus</v-icon>
                            </v-btn>
                        </template>
                        <template v-slot:append>
                            <v-btn
                                icon
                                variant="plain"
                                size="default"
                                :disabled="order_transport_data.quantity >= maxQuantity ? true : false"
                                @click="order_transport_data.quantity++"
                                >
                                <v-icon color="primary" size="24">mdi-plus</v-icon>
                            </v-btn>
                        </template>
                    </v-text-field>
                    <div v-if="order_transport_data.donor_material" class="mt-1 order-bar-info-text">
                        Dostępnych: {{ maxQuantity }}
                    </div>
                </div>
                <div :class="['order-bar-element d-flex flex-column align-start', $vuetify.display.mobile ? 'w-100' : '' ]">
                    <div class="order-bar-label mb-2 mt-md-0 mt-4">
                        Miejsce docelowe transportu
                    </div>
                    <div :class="['order-bar-select-wrapper', $vuetify.display.mobile ? '' : 'location-md-select-wrapper']">
                        <Select
                            v-model="order_transport_data.location"
                            id="location"
                            :clearIcon="false"
                            :options="locations.map(loc => ({ name: loc.name, value: loc }))"
                            :placeholder="'Wybierz miejsce'"
                            :sortData="true"
                            :class="invalidOrderTransportLocation ? 'error' : ''"
                            @change="onChangeLocation"
                            >
                            <template #option="{ option }">
                                <div>{{ option.name }}</div>
                            </template>
                        </Select>
                    </div>
                    <div v-if="invalidOrderTransportLocation" class="mt-1 order-bar-info-text error-text">
                        Proszę wybrać miejsce docelowe transportu.
                    </div>
                </div>
            </div>

            <v-divider class="my-md-3 my-6 mx-md-6"></v-divider>

            <div class="order-bar text-left pa-md-6 pa-0 d-flex flex-row align-center justify-end">
                <div class="order-btn-wrapper">
                    <v-btn
                        rounded
                        variant="outlined"
                        color="primary"
                        height="40"
                        class="text-uppercase"
                        @click="goToReservations"
                    >
                        Anuluj
                    </v-btn>
                    <v-btn
                        flat
                        rounded
                        color="primary"
                        height="40"
                        :class="['text-uppercase order-btn', ordering ? 'v-btn--disabled' : '']"
                        @click="submitOrderTransport"
                    >
                        Zleć transport
                    </v-btn>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Select } from "design-system-ui-components";
import { computed } from "vue";
import axios from "axios";

export default {
    name: "order-transport-component",
    data: () => {
        return {
            locations: [],
            allLocations: [],
            donorMaterials: [],
            maxQuantity: 1,
            order_transport_data: {
                donor_material: null,
                quantity: 1,
                location: null,
            },
            invalidOrderTransportDonorMaterial: false,
            invalidOrderTransportQuantity: false,
            invalidOrderTransportLocation: false,
            ordering: false,
        }
    },
    components: {
        Select
    },
    setup() {
        const box_icon = computed({
            get: () => { return require('@/assets/icons/box.svg'); }
        })
        return {
            box_icon
        }
    },
    created() {
    },
    mounted() {
        this.getDicts();
        this.loadDonorMaterials();
    },
    methods: {
        goToReservations() {
            this.$router.push({ name: 'coordinatorBookingComponent' });
        },
        submitOrderTransport() {
            this.validateForm().then((isValid) => {
                if (isValid) {
                    this.ordering = true;
                    axios.post('/api/coordinator/reservation', {
                        product_key: this.order_transport_data.donor_material.value.id,
                        material_type: this.order_transport_data.donor_material.value.material.type,
                        quantity: this.order_transport_data.quantity,
                        new_location_code: this.order_transport_data.location.value.code,
                    }).then(() => {
                        this.$router.push({ name: 'coordinatorBookingComponent' }).then(() => {
                            this.$root.$alertMessageRef.showAlert(
                                "Zlecenie transportu zostało zrealizowane pomyślnie.",
                                "",
                                {   
                                    positionFixed: true,
                                    class: 'mt-md-10 mt-2',
                                    link: false,
                                    action: false,
                                    timeout: true,
                                    timeoutDuration: 5000,
                                    color: 'rgba(32, 30, 76, 1)',
                                    backgroundColor: 'rgba(107, 215, 131, 0.2)',
                                    borderColor: 'rgba(107, 215, 131, 1)',
                                    icon: 'mdi-check-circle-outline',
                                    iconColor: 'rgba(107, 215, 131, 1)',
                                    width: 'auto'
                                }
                            )
                            this.showFilters = false;
                        });
                    }).catch((error) => {
                        console.error(error);
                        this.$root.$alertMessageRef.showAlert(
                            "Wystąpił błąd podczas składania zlecenia transportu.",
                            "Proszę spróbować ponownie później lub skontaktować się z obsługą systemu.",
                            {   
                                positionFixed: true,
                                class: 'mt-md-10 mt-2',
                                link: false,
                                action: false,
                                timeout: true,
                                timeoutDuration: 10000,
                                color: 'rgba(0, 32, 91, 1)',
                                backgroundColor: 'rgba(255, 235, 235, 1)',
                                borderColor: 'rgba(214, 0, 28, 1)',
                                icon: 'mdi-close-circle-outline',
                                iconColor: 'rgba(214, 0, 28, 1)',
                                width: '860px'
                            }
                        )
                    }).finally(() => {
                        this.ordering = false;
                    });
                }
            });
        },
        validateForm() {
            return new Promise((resolve) => {
                if (!this.order_transport_data.donor_material) {
                    this.invalidOrderTransportDonorMaterial = true;
                    resolve(false);
                    return;
                } else {
                    this.invalidOrderTransportDonorMaterial = false;
                }
                if (!this.order_transport_data.quantity || this.order_transport_data.quantity < 1 || this.order_transport_data.quantity > this.maxQuantity) {
                    this.invalidOrderTransportQuantity = true;
                    resolve(false);
                    return;
                } else {
                    this.invalidOrderTransportQuantity = false;
                }
                if (!this.order_transport_data.location) {
                    this.invalidOrderTransportLocation = true;
                    resolve(false);
                    return;
                } else {
                    this.invalidOrderTransportLocation = false;
                }
                resolve(true);
            });
        },
        loadDonorMaterials() {
            axios.post(`/api/coordinator/donor/mtSemen/data`, {
                "size": 10000,
                "_source": false,
                "script_fields": [
                    "age",
                    "max_true_reservation_count"
                ],
                "filters": []
                }).then((response) => {
                    response.data.data.forEach(item => {
                        this.donorMaterials.push({
                            name: `${item._source.donor_process.donor_id} / ${item._source.donor_process.donor_nickname}`,
                            value: {...item._source, ...item.fields}
                        });
                    });
                }).catch((error) => {
                    console.error(error);
                });

            axios.post(`/api/coordinator/donor/mtCell/data`, {
                "size": 10000,
                "_source": false,
                "script_fields": [
                    "age",
                    "max_true_reservation_count"
                ],
                "filters": []
                }).then((response) => {
                    response.data.data.forEach(item => {
                        this.donorMaterials.push({
                            name: `${item._source.donor_process.donor_id} / ${item._source.donor_process.donor_nickname}`,
                            value: {...item._source, ...item.fields}
                        });
                    });
                }).catch((error) => {
                    console.error(error);
                });
        },
        onChangeDonorMaterial(item) {
            this.order_transport_data.quantity = 1;
            this.order_transport_data.location = null;

            if(item) {
                this.invalidOrderTransportDonorMaterial = false;
            }

            if (item && item.value.max_true_reservation_count && item.value.max_true_reservation_count.length) {
                this.maxQuantity = item.value.max_true_reservation_count[0];
                if (this.order_transport_data.quantity > this.maxQuantity) {
                    this.order_transport_data.quantity = this.maxQuantity;
                }
            } else {
                this.maxQuantity = 1;
                this.order_transport_data.quantity = 1;
            }

            if (item && item.value.material && item.value.material.location) {
                this.locations = this.allLocations.filter(loc => loc.id !== item.value.material.location.id);
            } else {
                this.locations = this.allLocations;
            }
        },
        onChangeLocation(item) {
            if(item) {
                this.invalidOrderTransportLocation = false;
            }
        },
        getDicts() {
            return new Promise((resolve, reject) => {
            axios.get('/api/personal_data/dictionary')
                .then((response) => {
                    this.locations = response.data.location;
                    this.allLocations = response.data.location;
                    resolve(response);
                })
                .catch(error => {
                    console.error(error);
                    reject(error)
                })
            })
        },
        filter(data, text) {
            return data.filter((item) => item.name.toLowerCase().includes(text.toLowerCase()));
        }
    }
}
</script>

<style lang="scss" scoped>
:deep(.selectfield--item) {
    width: 272px;
    .selectfield--item-subtitle {
        font-size: 10px;
        color: var(--Text-accent-dark, #4B618B);
    }
}
:deep(.selectfield--no-items) {
    width: 272px;
    padding: var(--size-12);
}
:deep(svg.icon-expand-more) {
    color: $ds-primary !important;
}
:deep(.selectfield--selection>svg.icon-close) {
    color: $ds-primary !important;
}
:deep(.selectfield.error>.selectfield--selection>input) {
    border-color: $ds-error !important;
}

.back-to-booking-link {
    font-size: 12px;
    line-height: 18px;
    color: $ds-primary;
    text-decoration: none;
    gap: 8px;
}

.order-transport-component {
    box-sizing: border-box;
    background: none;
    max-width: 800px;
    .main-header {
        @include nsb-poppins-semibold;
    }
    .order-transport-wrapper {
        background: white;
        .order-transport-header {
            font-size: 16px;
            line-height: 26px;
        }
    }
    .v-divider {
        border-color: var(--borders-dividers-default, #E2E6EE) !important;
    }
    .v-input.set-quantity {
        width: 144px;
        height: 40px;
        border-radius: 4px;
        border: 1px solid rgb(var(--input-border-color));
        --v-input-control-height: 40px;
        --v-input-padding-top: 0px;
        :deep(.v-field__input) {
            color: $ds-primary; 
            font-size: 14px !important;
            line-height: 21px;
            min-width: 24px !important;
            text-align: center;

            &::-webkit-inner-spin-button {
                -webkit-appearance: none;
            }
            &[type=number] {
                -moz-appearance: textfield;
            }
        }
        .v-btn {
            opacity: 1;
            &.v-btn--disabled {
                opacity: 0.1;
            }
            &:hover {
                border: none !important;
            }
            &:focus,  &:focus-visible{
                border: none !important;
                outline: none !important;
            }
        }
    }
    .order-bar {
        max-width: 100%;
        .order-bar-element {
            .order-bar-label {
                @include nsb-font-container;
                font-size: 14px !important;
            }
            .order-bar-input, .order-bar-select {
                @include nsb-font-input;
                font-size: 16px !important;
                border-radius: 4px;
                border: 1px solid $ds-background-1 ;
                height: 40px;
                padding: 0px 16px;
                padding-right: 48px;
                outline: none;
                text-overflow: ellipsis;
                width: 100%;
                option {
                    text-overflow: ellipsis;
                    padding-right: 32px;
                }
            }
            .order-bar-info-text {
                font-size: 12px;
                color: var(--Text-accent-dark, #4B618B);
                &.error-text {
                    color: $ds-error;
                }
            }
            .order-bar-select-wrapper {
                position: relative;
                width: 100%;
            }
        }
        .order-btn-wrapper {
            display: flex;
            gap: 16px;
            .order-btn {
                &:hover {
                    border: none !important;
                }
                &:focus,  &:focus-visible {
                    border: none !important;
                    outline: none !important;
                }
            }
        }
    }
}
</style>